"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/RequestCard.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _requests = require('shared/selectors/requests');
var _team = require('shared/selectors/team');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');
var _KeywordChip = require('web/components/Requests/KeywordChip'); var _KeywordChip2 = _interopRequireDefault(_KeywordChip);





/* An open request, under the keyword line that opened it. Everyone on the
 * team sees it until one of them marks it handled; a reply doesn't clear it.
 * On success it leaves with the request; on failure it stays. */
const RequestCard = ({ request }) => {
  const senderName = _hooks.useAppSelector.call(void 0, state => _requests.selectRequestSenderName.call(void 0, state, request.BKey))
  const teamName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_team.selectTeamByKey.call(void 0, state, request.TeamKey), 'optionalAccess', _ => _.Name]), () => ( '')))
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)

  const onMarkHandled = _react.useCallback.call(void 0, () => {
    setIsSaving(true)
    _actions2.default.markRequestHandled(request.TodoKey).catch(() => {
      setIsSaving(false)
      showWarningBar('Failed to mark the request handled')
    })
  }, [request.TodoKey, showWarningBar])

  return (
    _react2.default.createElement('div', { className: "request-card", role: "group", 'aria-label': `Open request ${request.Keyword}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
      , _react2.default.createElement(_KeywordChip2.default, { keyword: request.Keyword, className: "request-card--chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
      , _react2.default.createElement('div', { className: "request-card--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
        , _react2.default.createElement('div', { className: "request-card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
          , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}, "Open request." ), " " ,  senderName , " sent "  ,  request.Keyword , "."
        )
        , _react2.default.createElement('div', { className: "request-card--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}, "Everyone on "
            ,  teamName , " sees this until someone marks it handled."
        )
      )
      , _react2.default.createElement('button', { type: "button", className: "request-card--btn", onClick: onMarkHandled, disabled: isSaving, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
        , _react2.default.createElement('svg', {
          width: 14,
          height: 14,
          viewBox: "0 0 24 24"   ,
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          'aria-hidden': "true",
          focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}

          , _react2.default.createElement('path', { d: "M20 6L9 17l-5-5"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}} )
        ), "Mark handled"

      )
    )
  )
}

exports. default = _react.memo.call(void 0, RequestCard)
